import React from 'react';
import CourierRoutePage from './CourierRoutePage';
import { ROUTE_PAGES } from '../data/routePages';

const CourierToUSAPage = () => <CourierRoutePage page={ROUTE_PAGES.usa} />;

export default CourierToUSAPage;
